import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { ForgotPasswordComponent } from './forgot-password/forgotPassword.component';
import { UnlockAccountComponent } from './unlock-account/UnlockAccountComponent';

// Page Layouts
import { PageLayoutFullscreenComponent } from './page-layouts/fullscreen/fullscreen.component';


const AppRoutes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'login/:id', component: LoginComponent },
    { path: 'registration', component: RegistrationComponent },
    { path: 'registration/:id', component: RegistrationComponent },
    { path: 'registration/apps/:id', component: RegistrationComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent},
    { path: 'unlock-account', component: UnlockAccountComponent},
    { path: 'app', component: LayoutComponent },
    { path: 'extra', loadChildren: './extra-pages/extra-pages.module#ExtraPagesModule' },
    { path: 'fullscreen', component: PageLayoutFullscreenComponent },
    { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, {useHash: true});



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app-routing.module.ts